import { isValidLaufzeit } from '@ps20-frontend/frontend-models';
import { convertDate } from '@ps20-frontend/utils';
import { Produkt } from '../model';

interface PickedVorvertrag {
  laufzeit: number | undefined;
  ablaufDatumLocal: string | undefined;
}

const EMPTY: PickedVorvertrag = { laufzeit: undefined, ablaufDatumLocal: undefined };

function toLocal(iso: string | undefined): string | undefined {
  return iso ? convertDate(iso) ?? undefined : undefined;
}

function pickVorvertragWithLongestLaufzeit(produkt: Produkt): PickedVorvertrag {
  const vorvertraege = produkt?.vorvertragsnummer;
  if (!vorvertraege?.length) {
    return EMPTY;
  }

  let longest: PickedVorvertrag | undefined;
  let fallbackAblaufIso: string | undefined;

  for (const vn of vorvertraege) {
    const laufzeit = vn.vorbelegungForBeibehaltung?.laufzeit;
    const ablaufIso = vn.vorbelegungForBeibehaltung?.ablaufDatum;
    if (isValidLaufzeit(laufzeit)) {
      if (!longest || laufzeit > longest.laufzeit) {
        longest = { laufzeit, ablaufDatumLocal: toLocal(ablaufIso) };
      }
    } else if (!fallbackAblaufIso && ablaufIso) {
      fallbackAblaufIso = ablaufIso;
    }
  }

  if (longest) {
    return longest;
  }
  return fallbackAblaufIso
    ? { laufzeit: undefined, ablaufDatumLocal: toLocal(fallbackAblaufIso) }
    : EMPTY;
}

export function selectVorvertragLaufzeit(produkt: Produkt): number | undefined {
  return pickVorvertragWithLongestLaufzeit(produkt).laufzeit;
}

export function selectVorvertragAblaufDatum(produkt: Produkt): string | undefined {
  return pickVorvertragWithLongestLaufzeit(produkt).ablaufDatumLocal;
}
